import React from 'react';
import { PageHero } from '../components/PageHero';
export function PrivacyPolicy() {
  return <div className="animate-fade-in-up" data-id="element-478">
      <PageHero title="Privacy Policy" subtitle="Effective Date: February 9, 2026" data-id="element-479" />
      <section className="py-16 md:py-24 bg-white" data-id="element-480">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12 text-teal/80 leading-relaxed" data-id="element-481">
          <div className="space-y-4" data-id="element-482">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-483">
              Our Commitment to Your Privacy
            </h2>
            <p data-id="element-484">
              At Arrive Psychotherapy & Wellness, your privacy is fundamental to
              the trust you place in us. This Privacy Policy explains how we
              collect, use, store, and protect your personal health information
              in accordance with Ontario's Personal Health Information
              Protection Act, 2004 (PHIPA).
            </p>
          </div>

          <div className="space-y-4" data-id="element-485">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-486">
              Who We Are
            </h2>
            <p data-id="element-487">
              Arrive Psychotherapy & Wellness
              <br data-id="element-488" />
              Jessica Ruppert, MA, Registered Psychotherapist (Qualifying)
              <br data-id="element-489" />
              Regulated by the College of Registered Psychotherapists of Ontario
              (CRPO)
              <br data-id="element-490" />
              Email: jess@arrivetherapy.ca
              <br data-id="element-491" />
              Website: arrivetherapy.ca
            </p>
            <p data-id="element-492">
              As a Registered Psychotherapist (Qualifying) in Ontario, I am a
              Health Information Custodian under PHIPA and am responsible for
              protecting your personal health information.
            </p>
          </div>

          <div className="space-y-4" data-id="element-493">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-494">
              What Information We Collect
            </h2>
            <h3 className="text-xl font-medium text-sage" data-id="element-495">
              Personal Health Information (PHI)
            </h3>
            <p data-id="element-496">
              We collect information about you that relates to your physical or
              mental health, the provision of healthcare services, and your
              identity. This includes:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-497">
              <li data-id="element-498">
                <strong data-id="element-499">Contact Information:</strong> Full name, date of birth,
                address, phone number(s), email address
              </li>
              <li data-id="element-500">
                <strong data-id="element-501">Health Information:</strong> Presenting concerns and
                reasons for seeking therapy, mental health history, relevant
                medical history, current medications, family health history
                (when relevant), emergency contact information, information
                about previous therapy or treatment, insurance information (if
                applicable)
              </li>
              <li data-id="element-502">
                <strong data-id="element-503">Treatment Records:</strong> Session notes and clinical
                observations, treatment plans and goals, progress notes,
                assessment results, communications between us (emails, messages,
                etc.), attendance records
              </li>
              <li data-id="element-504">
                <strong data-id="element-505">Referral Information:</strong> Name and contact
                information of any professional who referred you, reason for
                referral
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-506">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-507">
              How We Collect Your Information
            </h2>
            <p data-id="element-508">
              We collect your personal health information directly from you
              through:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-509">
              <li data-id="element-510">Intake forms completed before your first session</li>
              <li data-id="element-511">Verbal information you share during therapy sessions</li>
              <li data-id="element-512">Written communications (emails, secure messages, forms)</li>
              <li data-id="element-513">Third-party referrals (with your consent)</li>
            </ul>
            <p data-id="element-514">
              All information collection happens through our secure practice
              management platform, Owl Practice, which stores data on Canadian
              servers.
            </p>
          </div>

          <div className="space-y-4" data-id="element-515">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-516">
              How We Use Your Information
            </h2>
            <h3 className="text-xl font-medium text-sage" data-id="element-517">Primary Uses:</h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-518">
              <li data-id="element-519">Providing psychotherapy services to you</li>
              <li data-id="element-520">Planning and delivering your treatment</li>
              <li data-id="element-521">Maintaining accurate clinical records</li>
              <li data-id="element-522">Communicating with you about appointments and treatment</li>
              <li data-id="element-523">Processing payments and issuing receipts</li>
            </ul>
            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-524">
              Secondary Uses (with your consent or as required by law):
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-525">
              <li data-id="element-526">
                Clinical supervision (your information is shared with my
                clinical supervisor - you will be informed and asked to consent)
              </li>
              <li data-id="element-527">
                Consultation with other healthcare providers (only with your
                explicit consent)
              </li>
              <li data-id="element-528">Responding to legal requests or court orders</li>
              <li data-id="element-529">
                Complying with mandatory reporting obligations (child abuse,
                threat of serious harm)
              </li>
              <li data-id="element-530">
                Quality assurance and professional development (de-identified
                information only)
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-531">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-532">
              Clinical Supervision
            </h2>
            <p data-id="element-533">
              As a Registered Psychotherapist (Qualifying), I practice under
              clinical supervision as required by CRPO. This means:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-534">
              <li data-id="element-535">
                Your clinical information (including identifying information)
                will be shared with my clinical supervisor
              </li>
              <li data-id="element-536">
                You will be informed of my supervisor's name and contact
                information
              </li>
              <li data-id="element-537">
                You have the right to contact my supervisor with questions or
                concerns about your care
              </li>
              <li data-id="element-538">
                Your consent to supervision is obtained as part of your informed
                consent to therapy
              </li>
              <li data-id="element-539">
                All supervisors are bound by the same confidentiality and
                privacy obligations as I am
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-540">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-541">
              How We Store and Protect Your Information
            </h2>
            <h3 className="text-xl font-medium text-sage" data-id="element-542">
              Electronic Records:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-543">
              <li data-id="element-544">
                All client records are stored in Owl Practice, a PHIPA-compliant
                practice management system
              </li>
              <li data-id="element-545">
                Data is stored on secure Canadian servers (Montreal, Quebec)
              </li>
              <li data-id="element-546">End-to-end encryption for all data transmission</li>
              <li data-id="element-547">Password-protected access with two-factor authentication</li>
              <li data-id="element-548">Automatic logout after periods of inactivity</li>
              <li data-id="element-549">
                Electronic audit logs that track every access to your records
              </li>
              <li data-id="element-550">Regular security updates and monitoring</li>
            </ul>
            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-551">
              Virtual Sessions:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-552">
              <li data-id="element-553">Video sessions use end-to-end encryption</li>
              <li data-id="element-554">
                No session recordings are made unless you explicitly request and
                consent
              </li>
              <li data-id="element-555">
                Sessions are conducted over secure, private internet connections
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-556">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-557">
              Third-Party Service Providers
            </h2>
            <div className="bg-neutral-soft p-6 rounded-lg border-l-4 border-terracotta" data-id="element-558">
              <h3 className="text-xl font-medium text-teal mb-2" data-id="element-559">
                Owl Practice (Practice Management & Telehealth)
              </h3>
              <ul className="space-y-2 text-sm" data-id="element-560">
                <li data-id="element-561">
                  <strong data-id="element-562">Purpose:</strong> Client scheduling, clinical records,
                  billing, secure messaging, video sessions
                </li>
                <li data-id="element-563">
                  <strong data-id="element-564">Data Location:</strong> Canadian servers (Montreal,
                  Quebec)
                </li>
                <li data-id="element-565">
                  <strong data-id="element-566">Compliance:</strong> PHIPA and PIPEDA compliant
                </li>
                <li data-id="element-567">
                  <strong data-id="element-568">Access:</strong> Owl Practice acts as our "agent"
                  under PHIPA and has limited access to your information only as
                  needed to provide technical services
                </li>
                <li data-id="element-569">
                  <strong data-id="element-570">Privacy Policy:</strong>{' '}
                  <a href="https://owlpractice.ca/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-571">
                    https://owlpractice.ca/privacy-policy
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="space-y-4" data-id="element-572">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-573">
              Sharing Your Information
            </h2>
            <h3 className="text-xl font-medium text-sage" data-id="element-574">
              With Your Consent:
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-575">
              <li data-id="element-576">
                We will only share your personal health information with other
                healthcare providers, family members, or third parties with your
                explicit, informed consent
              </li>
              <li data-id="element-577">You can withdraw consent at any time</li>
            </ul>
            <h3 className="text-xl font-medium text-sage mt-4" data-id="element-578">
              Without Your Consent (as permitted or required by law):
            </h3>
            <ul className="list-disc pl-5 space-y-2" data-id="element-579">
              <li data-id="element-580">To my clinical supervisor (for supervision purposes)</li>
              <li data-id="element-581">
                To prevent or address a serious threat to your health or safety
                or that of another person
              </li>
              <li data-id="element-582">As required by law (e.g., court order, subpoena)</li>
              <li data-id="element-583">
                To comply with mandatory reporting obligations (child abuse,
                sexual abuse of a client by a regulated health professional)
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-584">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-585">
              Your Rights Under PHIPA
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-586">
              <li data-id="element-587">
                <strong data-id="element-588">Right to Access:</strong> You have the right to request
                access to your clinical records. Submit your request in writing
                to contact@arrivetherapy.ca. We will respond within 30 days of
                receiving your request.
              </li>
              <li data-id="element-589">
                <strong data-id="element-590">Right to Correction:</strong> If you believe your
                clinical records contain an error or are incomplete, you may
                request a correction in writing. We will respond within 30 days.
              </li>
              <li data-id="element-591">
                <strong data-id="element-592">Right to Request Restrictions:</strong> You may request
                that we restrict the use or disclosure of your information.
              </li>
              <li data-id="element-593">
                <strong data-id="element-594">Right to Withdraw Consent:</strong> You may withdraw
                your consent to the use or disclosure of your information at any
                time.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-595">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-596">
              Retention of Records
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-597">
              <li data-id="element-598">
                <strong data-id="element-599">Adults:</strong> Records are kept for a minimum of 10
                years from the date of your last appointment
              </li>
              <li data-id="element-600">
                <strong data-id="element-601">Minors:</strong> Records are kept for a minimum of 10
                years after you turn 18 years old
              </li>
            </ul>
            <p data-id="element-602">
              After the retention period, records are securely destroyed in
              accordance with PHIPA.
            </p>
          </div>

          <div className="space-y-4" data-id="element-603">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-604">
              Cookies and Website Data
            </h2>
            <ul className="list-disc pl-5 space-y-2" data-id="element-605">
              <li data-id="element-606">
                <strong data-id="element-607">Essential Cookies:</strong> Session cookies to maintain
                your browsing session. These are necessary for the website to
                function and cannot be disabled.
              </li>
              <li data-id="element-608">
                <strong data-id="element-609">No Marketing Cookies:</strong> We do not use cookies for
                advertising or marketing purposes. We do not sell or share your
                browsing data with third parties.
              </li>
            </ul>
          </div>

          <div className="space-y-4" data-id="element-610">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-611">
              Breach Notification
            </h2>
            <p data-id="element-612">
              In the unlikely event of a privacy breach involving your personal
              health information:
            </p>
            <ul className="list-disc pl-5 space-y-2" data-id="element-613">
              <li data-id="element-614">We will investigate the breach immediately</li>
              <li data-id="element-615">
                We will notify you if there is a real risk of significant harm
              </li>
              <li data-id="element-616">
                We will report the breach to the Information and Privacy
                Commissioner of Ontario as required by law
              </li>
            </ul>
          </div>

          <div className="space-y-4 border-t border-sage/20 pt-8" data-id="element-617">
            <h2 className="text-2xl md:text-3xl font-medium text-teal" data-id="element-618">
              Questions, Concerns, or Complaints
            </h2>
            <p data-id="element-619">
              Jessica Ruppert, MA, RP (Qualifying) Arrive Psychotherapy &
              Wellness Email: jess@arrivetherapy.ca
            </p>
            <div className="mt-6" data-id="element-620">
              <p className="font-medium mb-2" data-id="element-621">To file a complaint:</p>
              <p className="mb-4" data-id="element-622">
                <strong data-id="element-623">Information and Privacy Commissioner of Ontario</strong>
                <br data-id="element-624" />
                2 Bloor Street East, Suite 1400
                <br data-id="element-625" />
                Toronto, ON M4W 1A8
                <br data-id="element-626" />
                Phone: 416-326-3333 or 1-800-387-0073
                <br data-id="element-627" />
                Website:{' '}
                <a href="https://www.ipc.on.ca" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-628">
                  www.ipc.on.ca
                </a>
              </p>
              <p data-id="element-629">
                <strong data-id="element-630">
                  College of Registered Psychotherapists of Ontario
                </strong>
                <br data-id="element-631" />
                375 University Avenue, Suite 800
                <br data-id="element-632" />
                Toronto, ON M5G 2J5
                <br data-id="element-633" />
                Phone: 416-479-4330 or 1-844-712-1364
                <br data-id="element-634" />
                Email: info@crpo.ca
                <br data-id="element-635" />
                Website:{' '}
                <a href="https://www.crpo.ca" target="_blank" rel="noopener noreferrer" className="text-terracotta hover:underline" data-id="element-636">
                  www.crpo.ca
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>;
}